/**
 * @generated SignedSource<<f5cbadaad53d9b6f3c2e07d23dbb9657>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAnonymousAttachmentInput = {
  attachmentId: string;
  clientMutationId: string;
  code: string;
  tenantId: string;
};
export type useDeleteAnonymousAttachmentMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteAnonymousAttachmentInput;
};
export type useDeleteAnonymousAttachmentMutation$data = {
  readonly deleteAnonymousAttachment: {
    readonly attachment: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly message: string;
      readonly path: ReadonlyArray<string>;
      readonly type: string;
    }> | null;
  } | null;
};
export type useDeleteAnonymousAttachmentMutation = {
  response: useDeleteAnonymousAttachmentMutation$data;
  variables: useDeleteAnonymousAttachmentMutation$variables;
};
const node: ConcreteRequest = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    },
    v2 = [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }],
    v3 = {
      "alias": null,
      "args": null,
      "concreteType": "MutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "path",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }],
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/],

      "kind": "Fragment",
      "metadata": null,
      "name": "useDeleteAnonymousAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v2 /*: any*/,
        "concreteType": "DeleteAnonymousAttachmentPayload",
        "kind": "LinkedField",
        "name": "deleteAnonymousAttachment",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v4 /*: any*/],

          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1 /*: any*/, v0 /*: any*/],

      "kind": "Operation",
      "name": "useDeleteAnonymousAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v2 /*: any*/,
        "concreteType": "DeleteAnonymousAttachmentPayload",
        "kind": "LinkedField",
        "name": "deleteAnonymousAttachment",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v4 /*: any*/, {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [{
              "kind": "Variable",
              "name": "connections",
              "variableName": "connections"
            }]
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "ca55530b0946506d7f916b663f235d23",
      "id": null,
      "metadata": {},
      "name": "useDeleteAnonymousAttachmentMutation",
      "operationKind": "mutation",
      "text": "mutation useDeleteAnonymousAttachmentMutation(\n  $input: DeleteAnonymousAttachmentInput!\n) {\n  deleteAnonymousAttachment(input: $input) {\n    errors {\n      code\n      path\n      message\n      type\n    }\n    attachment {\n      id\n    }\n  }\n}\n"
    }
  };
}();
(node as any).hash = "da6df97dd85799100fd17f22ed682c35";
export default node;